import script from "./ChangePasswordForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChangePasswordForm.vue?vue&type=script&setup=true&lang=ts"

import "./ChangePasswordForm.vue?vue&type=style&index=0&id=25351080&lang=scss"

const __exports__ = script;

export default __exports__